import React, {useContext} from 'react';
import {NoteBookReportContext} from "./NoteBookReportContext"
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import "../BalanceSheet2/balacesheet2.scss"
import FilterSection from "./FilterSection";
import MainSection from "./MainSection";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";

function NoteBookReport() {

  const [data, setData] = objectDataHolder({
    reportType: "1",
    filter: {type: "all", year: "", month: "", startDate: "", endDate: "", firstId: "", lastId: "",}, // ارسال هنگام درخواست گزارش نهایی
    level: [], // برای مشاهده فیلتر ثانویه لول لازم داریم چک زد پر بشه سورت بشه
    // وقتی مشاهده فیلتر ثانویه رو زد یا چک باکس زد درخواست میره سمت بک و بک اینو پر میکنه
    // من متوجه میشم که دیتای1 همون چیزی که توی صفحه دوم به کاربر نشون بدم
    data1: {
      group: [{accountCode: "22", accountName: "عنوان", A1: "", A2: "", A3: "", A4: "", level: ""}],
      kol: [],
      moien: [],
      tafsil: [],
    }, // به آرایه از آبجکت ها که هر آبجکت ینی یه دونه تیک زده  که مقدار لول و اکانت کد و سایر اطلاعاتش میاد
    prevFilter: [], // نتیجه نهایی وقتی کاربر کلیک میکنه روی دکمه گزارش توی این کلید ریخته میشه
    data2: [],

  })

  return (<NoteBookReportContext.Provider value={{data, setData}}>
    <div className={"note__book__report"}>
      <FilterSection/>
      <MainSection/>
    </div>
  </NoteBookReportContext.Provider>);
}

export default NoteBookReport;